import { configureStore } from "@reduxjs/toolkit";
import userAuthSlice from "./user/slice/userAuthSlice";
import commonModuleSlice from "./common/slice/commonSlice";

export const store = configureStore({
  reducer: {
    userAuth: userAuthSlice,
   
  },
});
